import { DaoModel } from '@dynameat/models';

export class MenuBannerRecommendation extends DaoModel {
  constructor(guid, title, textAlt1, textAlt2, textAlt3, image, activeByDefault, menu, product,
    timeStart, timeEnd, monday, tuesday, wednesday, thursday, friday, saturday, sunday) {
    super(guid);
    this.title = title || '';
    this.textAlt1 = textAlt1 || '';
    this.textAlt2 = textAlt2 || '';
    this.textAlt3 = textAlt3 || '';
    this.image = image || null;
    this.activeByDefault = activeByDefault || false;
    this.menu = menu || null;
    this.product = product || null;
    this.timeStart = timeStart;
    this.timeEnd = timeEnd;
    this.monday = monday || false;
    this.tuesday = tuesday || false;
    this.wednesday = wednesday || false;
    this.thursday = thursday || false;
    this.friday = friday || false;
    this.saturday = saturday || false;
    this.sunday = sunday || false;
  }

  static toInstance(props = {}) {
    return new MenuBannerRecommendation(
      props.guid, props.title, props.text_alt1, props.text_alt2, props.text_alt3, props.image,
      props.active_by_default, props.menu, props.product, props.time_start, props.time_end, props.monday,
      props.tuesday, props.wednesday, props.thursday, props.friday, props.saturday, props.sunday,
    );
  }

  getFormData() {
    const formData = new FormData();
    formData.append('guid', this.guid);
    formData.append('title', this.title);
    formData.append('text_alt1', this.textAlt1);
    formData.append('text_alt2', this.textAlt2);
    formData.append('text_alt3', this.textAlt3);
    formData.append('active_by_default', this.activeByDefault);
    formData.append('menu', this.menu);
    formData.append('product', this.product ? this.product : '');
    formData.append('monday', this.monday);
    formData.append('tuesday', this.tuesday);
    formData.append('wednesday', this.wednesday);
    formData.append('thursday', this.thursday);
    formData.append('friday', this.friday);
    formData.append('saturday', this.saturday);
    formData.append('sunday', this.sunday);

    if (this.timeStart || this.timeEnd) {
      formData.append('time_start', this.timeStart);
      formData.append('time_end', this.timeEnd);
    }

    if (this.image instanceof File) {
      if (this.image.size !== 0) {
        formData.append('image', this.image, this.image.name);
      }
    } else if (!this.image) {
      formData.append('image', '');
    }
    return formData;
  }

  get text() {
    return this.translateAttributeCamel('text');
  }
}
